import numeral from 'numeral';

import { appConfig } from 'config/customization';
import { message } from 'utils/stringUtils';

const { columns } = appConfig.payments;

export const retrieveColumns = (checkboxRenderer, amountRenderer, downloadRenderer) =>
  [
    {
      key: '',
      name: '',
      width: columns.checkbox.width,
      order: columns.checkbox.order,
      cellRenderer: checkboxRenderer,
      show: columns.checkbox.show
    },
    {
      key: 'period',
      name: message('Bills:period'),
      width: columns.period.width,
      order: columns.period.order,
      show: columns.period.show
    },
    {
      key: 'issued_on',
      name: message('Bill:issued_on'),
      width: columns.issued_on.width,
      order: columns.issued_on.order,
      show: columns.issued_on.show
    },
    {
      key: 'document_type',
      name: message('Bills:documentType'),
      width: columns.document_type.width,
      order: columns.document_type.order,
      show: columns.document_type.show
    },
    {
      key: 'document_number',
      name: message('Bill:document_number'),
      width: columns.document_number.width,
      order: columns.document_number.order,
      show: columns.document_number.show
    },
    {
      key: 'first_expiration_on',
      name: message('Bills:expiration'),
      width: columns.first_expiration_on.width,
      order: columns.first_expiration_on.order,
      show: columns.first_expiration_on.show
    },
    {
      key: 'status',
      name: message('Commons:status'),
      width: columns.status.width,
      order: columns.status.order,
      show: columns.status.show
    },
    {
      key: 'amount',
      name: message('Bills:amount'),
      width: columns.amount.width,
      order: columns.amount.order,
      cellRenderer: amountRenderer,
      show: columns.amount.show
    },
    {
      key: 'balance',
      name: message('Bills:balance'),
      width: columns.balance.width,
      order: columns.balance.order,
      cellRenderer: amountRenderer,
      show: columns.balance.show
    },
    {
      key: 'barcode',
      name: message('Bills:barcode'),
      width: columns.barcode.width,
      order: columns.barcode.order,
      show: columns.barcode.show
    },
    {
      key: 'external_id',
      name: message('Bills:externalId'),
      width: columns.external_id.width,
      order: columns.external_id.order,
      show: columns.external_id.show
    },
    {
      key: '',
      name: message('Payments:paymentDocument'),
      width: columns.download.width,
      order: columns.download.order,
      cellRenderer: downloadRenderer,
      show: columns.download.show
    }
  ]
    .filter(column => column.show)
    .sort((a, b) => (a.order < b.order ? -1 : 1));

export const retrieveMobileColumns = (bill, list, handleOnChange, mobileDownloadRenderer) =>
  [
    {
      value: bill,
      onCheck: handleOnChange,
      checked:
        list.findIndex(
          item =>
            (bill.external_id || bill.value.external_id) === (item.external_id || item.value.external_id)
        ) !== -1,
      label: bill.document_number,
      fieldRenderer: 'HeaderField',
      show: columns.checkbox.showOnMobile
    },
    {
      value: bill.period,
      field: message('Bills:period').toUpperCase(),
      fieldRenderer: 'TextField',
      show: columns.period.showOnMobile
    },
    {
      value: bill.document_type,
      field: message('Bills:documentType').toUpperCase(),
      fieldRenderer: 'TextField',
      show: columns.document_type.showOnMobile
    },
    {
      value: bill.document_number,
      field: message('Bill:document_number').toUpperCase(),
      fieldRenderer: 'TextField',
      show: columns.document_number.showOnMobile
    },
    {
      value: bill.first_expiration_on,
      field: message('Bills:expiration').toUpperCase(),
      fieldRenderer: 'TextField',
      show: columns.first_expiration_on.showOnMobile
    },
    {
      value: bill.status,
      field: message('Commons:status').toUpperCase(),
      fieldRenderer: 'TextField',
      show: columns.status.showOnMobile
    },
    {
      value: numeral(bill.amount).format('$0,0.[00]'),
      field: message('Bills:amount').toUpperCase(),
      fieldRenderer: 'TextField',
      show: columns.amount.showOnMobile
    },
    {
      value: numeral(bill.balance).format('$0,0.[00]'),
      field: message('Bills:balance').toUpperCase(),
      fieldRenderer: 'TextField',
      show: columns.balance.showOnMobile
    },
    {
      value: bill.barcode,
      field: message('Bills:barcode').toUpperCase(),
      fieldRenderer: 'TextField',
      show: columns.barcode.showOnMobile
    },
    {
      value: bill.external_id,
      field: message('Bills:externalId').toUpperCase(),
      fieldRenderer: 'TextField',
      show: columns.external_id.showOnMobile
    },
    {
      fieldRenderer: mobileDownloadRenderer(bill),
      show: columns.download.showOnMobile
    }
  ].filter(element => element.show);
